import React, { lazy } from 'react';
import type { InsuranceQuoteProps } from './insurance-quote';

const InsuranceQuoteComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-insurance-quote" */ '|/app/purchase/order-placed/insurance-quote'
    )
);

export const InsuranceQuoteRoute = (props: InsuranceQuoteProps) => (
  <InsuranceQuoteComponent {...props} />
);
